;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';
	var View = APP.module('View');
	View.HelpFaqs = Marionette.ItemView.extend({
		template: JST.helpFaqs,
		tagName: 'div',
		ui: {
			"parentToggle": ".parent-toggle",
			"childToggle": ".child-toggle"
		},
		events: {
			"click @ui.parentToggle": "toggleCategory",
			"click @ui.childToggle": "toggleQuestion"
		},
		initialize: function () {
			this.model.appendScript( this );
			this.model.set('categories', {});

		},
		toggleCategory: function (e) {
			e.preventDefault();
			var $this = $(e.target),
				$parent = $this.parent();

			$this.toggleClass('opened');
			$parent.toggleClass('opened');
			$parent.find('.child').removeClass('opened');
			$parent.find('.child-toggle').removeClass('opened');
		},
		toggleQuestion: function (e) {
			e.preventDefault();
			var $this = $(e.target);
			$this.toggleClass('opened');
			$this.parent().toggleClass('opened');
		},
		showContent: function () {
			var property = this.model.property,
				r = EXPORTS.GLOBAL_DATA[property],
				faqs_by_type = [],
				categories = [],
				i, j, type
				;

			type = 'global';

			for (i = 0; i < r.game_types.length; i++) {
				if (r.game_types[i].type == type) {
					faqs_by_type[i] = this.model.getFaqsList(r, r.game_types[i].type);
				}
			}

			for (i = 0; i < faqs_by_type.length; i++) {
				if (faqs_by_type[i]) {
					for (j = 0; j < faqs_by_type[i].length; j++) {
						categories.push(faqs_by_type[i][j]);
					}
				}
			}

			this.$el.html(
				this.template({
					categories: categories
				})
			);
		}
	});

}(window, APP, Backbone, Marionette, $, _));